const api = {
    CustomerOrderGet: '/open/common/customer/order/get/list/',
    CustomerRefundApplySubmit: '/open/common/customer/refund/apply/submit',
    CustomerComplaintSubmit: '/open/common/customer/complaint/submit',
    CustomerAllOrderGet: '/open/common/customer/order/get/allList/',
    CustomerAllRefundApplySubmit: '/open/common/customer/refund/apply/submitList',
    CustomerGetRefundableOrders: '/open/common/customer/order/get/refundableOrders',

    CustomerAutoRefund: '/open/common/customer/refund/autoRefund',
    CustomerAutoComplaint: '/open/common/customer/refund/autoComplaint',
}

export default api